/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Domain } from './Domain';
import {
    DomainFromJSON,
    DomainFromJSONTyped,
    DomainToJSON,
    DomainToJSONTyped,
} from './Domain';
import type { Workspace } from './Workspace';
import {
    WorkspaceFromJSON,
    WorkspaceFromJSONTyped,
    WorkspaceToJSON,
    WorkspaceToJSONTyped,
} from './Workspace';

/**
 * 
 * @export
 * @interface AvailableDomainsResponse
 */
export interface AvailableDomainsResponse {
    /**
     * The domain being evaluated for availability
     * @type {Domain}
     * @memberof AvailableDomainsResponse
     */
    domain: Domain;
    /**
     * Indicates if the domain is available to be added to the workspace.
     * @type {boolean}
     * @memberof AvailableDomainsResponse
     */
    available: boolean;
    /**
     * If not available, the reason why not.
     * @type {string}
     * @memberof AvailableDomainsResponse
     */
    availableReason: AvailableDomainsResponseAvailableReasonEnum;
    /**
     * The workspace that the domain is already in, if any.
     * @type {Workspace}
     * @memberof AvailableDomainsResponse
     */
    workspace?: Workspace;
}


/**
 * @export
 */
export const AvailableDomainsResponseAvailableReasonEnum = {
    Available: 'AVAILABLE',
    AlreadyInCurrentWorkspace: 'ALREADY_IN_CURRENT_WORKSPACE',
    AlreadyInWorkspace: 'ALREADY_IN_WORKSPACE',
    NotProDomain: 'NOT_PRO_DOMAIN'
} as const;
export type AvailableDomainsResponseAvailableReasonEnum = typeof AvailableDomainsResponseAvailableReasonEnum[keyof typeof AvailableDomainsResponseAvailableReasonEnum];


/**
 * Check if a given object implements the AvailableDomainsResponse interface.
 */
export function instanceOfAvailableDomainsResponse(value: object): value is AvailableDomainsResponse {
    if (!('domain' in value) || value['domain'] === undefined) return false;
    if (!('available' in value) || value['available'] === undefined) return false;
    if (!('availableReason' in value) || value['availableReason'] === undefined) return false;
    return true;
}

export function AvailableDomainsResponseFromJSON(json: any): AvailableDomainsResponse {
    return AvailableDomainsResponseFromJSONTyped(json, false);
}

export function AvailableDomainsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AvailableDomainsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'domain': DomainFromJSON(json['domain']),
        'available': json['available'],
        'availableReason': json['availableReason'],
        'workspace': json['workspace'] == null ? undefined : WorkspaceFromJSON(json['workspace']),
    };
}

export function AvailableDomainsResponseToJSON(json: any): AvailableDomainsResponse {
    return AvailableDomainsResponseToJSONTyped(json, false);
}

export function AvailableDomainsResponseToJSONTyped(value?: AvailableDomainsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'domain': DomainToJSON(value['domain']),
        'available': value['available'],
        'availableReason': value['availableReason'],
        'workspace': WorkspaceToJSON(value['workspace']),
    };
}

